<template>
  <transition name="confirm-fade">
    <div v-if="visible" class="confirm-mask" @click.self="cancel">
      <div class="confirm-box">
        <div class="confirm-title">{{ title }}</div>
        <div class="confirm-content">{{ content }}</div>
        <div v-if="showCancel || showConfirm" class="confirm-footer">
          <button v-if="showCancel" class="btn-cancel" @click="cancel">取消</button>
          <button v-if="showConfirm" class="btn-confirm" @click="confirm">确定</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      title: '提示',
      content: '',
      showCancel: true,
      showConfirm: true,
      resolve: null,
      reject: null
    }
  },
  methods: {
    open({ title, content, showCancel = true, showConfirm = true }) {
      this.title = title || '提示'
      this.content = content || ''
      this.showCancel = showCancel !== false // 默认显示，只有明确传 false 才隐藏
      this.showConfirm = showConfirm !== false // 默认显示，只有明确传 false 才隐藏
      this.visible = true
      // 禁止背景滚动
      document.body.style.overflow = 'hidden'

      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    confirm() {
      this.visible = false
      document.body.style.overflow = ''
      this.resolve && this.resolve(true)
    },
    cancel() {
      this.visible = false
      document.body.style.overflow = ''
      this.reject && this.reject(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.confirm-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.confirm-box {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  min-width: 400px;
  max-width: 500px;
  overflow: hidden;
  animation: confirm-slide-in 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes confirm-slide-in {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.confirm-title {
  padding: 24px 24px 16px;
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  border-bottom: 1px solid #f0f0f0;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}

.confirm-content {
  padding: 24px;
  font-size: 14px;
  color: #666666;
  line-height: 1.6;
  min-height: 60px;
  word-break: break-word;
}

.confirm-footer {
  padding: 16px 24px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}

.btn-cancel,
.btn-confirm {
  padding: 10px 24px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  outline: none;
  font-weight: 500;
}

.btn-cancel {
  background-color: #ffffff;
  color: #666666;
  border: 1px solid #e0e0e0;

  &:hover {
    background-color: #f5f5f5;
    border-color: #d0d0d0;
  }

  &:active {
    opacity: 0.8;
  }
}

.btn-confirm {
  background-color: $primary-color;
  color: #ffffff;

  &:hover {
    background-color: #0fa8a3;
    box-shadow: 0 4px 12px rgba($primary-color, 0.3);
  }

  &:active {
    opacity: 0.9;
    transform: scale(0.98);
  }
}

// 过渡动画
.confirm-fade-enter-active,
.confirm-fade-leave-active {
  transition: opacity 0.3s ease;
}

.confirm-fade-enter-active .confirm-box,
.confirm-fade-leave-active .confirm-box {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.confirm-fade-enter,
.confirm-fade-leave-to {
  opacity: 0;
}

.confirm-fade-enter .confirm-box,
.confirm-fade-leave-to .confirm-box {
  transform: translateY(-20px) scale(0.95);
  opacity: 0;
}

// 响应式设计
@media screen and (max-width: 576px) {
  .confirm-box {
    min-width: 90%;
    max-width: 90%;
  }

  .confirm-title {
    padding: 20px 20px 12px;
    font-size: 16px;
  }

  .confirm-content {
    padding: 20px;
    font-size: 14px;
  }

  .confirm-footer {
    padding: 12px 20px 20px;
    flex-direction: column-reverse;
    gap: 10px;

    button {
      width: 100%;
    }
  }
}
</style>
